import { makeQueryParams } from 'utils/makeQueryParams'
import { api } from '../../../api'
import {
  PaginatedReportsResponseTypes,
  ReportSearchPropTypes
} from '../Reports.types'
import { AssignmentsStudentsReportTypes } from './assignments.types'

const allAssignments = async ({
  params: { page = 1, ...rest }
}: ReportSearchPropTypes) => {
  return api
    .get<PaginatedReportsResponseTypes<AssignmentsStudentsReportTypes>>(
      `v2/reports/assignments${makeQueryParams({
        selectedPage: page,
        ...rest
      })}`
    )
    .then((response) => response.data)
}

export default allAssignments
